$(document).on('click', '.product-form__cart-submit', function () {
  var checkedValue = $.map($('.add-on-product-checkbox:checked'), function (c) { return c.value; })
  //alert(Number(checkedValue));  
  if (Number(checkedValue) > 0) {
    console.log("add on product : " + checkedValue);
    setTimeout(() => {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: checkedValue
        },
        dataType: 'json',
        success: function (data) {
          //alert("Product Added..");
        },
        error: function (xhr, status, error) {
          var returnres = JSON.parse(xhr.responseText);
          alert("add on product : " + $.trim(returnres.description));
        }
      });
    }, "1000");
  }
});

// handle "add order notes" button states for accessibility

const addOrderNotesButton = document.querySelector('#add-order-notes')
const addOrderNotesContent = document.querySelector('#add-order-notes-content')

const addOrderNotesobserver = new MutationObserver(function (mutationsList) {
  mutationsList.forEach(function (mutation) {
    if (mutation.attributeName === 'style') {
      const displayStyle = window.getComputedStyle(addOrderNotesContent).display

      if (displayStyle === 'none') {
        addOrderNotesButton.setAttribute('aria-expanded', false)
      } else if (displayStyle === 'block') {
        addOrderNotesButton.setAttribute('aria-expanded', true)
      } else {
        addOrderNotesButton.setAttribute('aria-expanded', false)
      }
    }
  })
})

const addOrderNotesContentConfig = {
  attributes: true,
  attributeFilter: ['style']
}

if (addOrderNotesContent) {
  addOrderNotesobserver.observe(addOrderNotesContent, addOrderNotesContentConfig)
}

// handle accessibility for the featured carousels

const featuredTabButtons = document.querySelectorAll('.featured-collection-slider__navigation-list-item')

if (featuredTabButtons.length > 0) {
  featuredTabButtons.forEach((tab) => {
    tab.addEventListener('click', () => {
      featuredTabButtons.forEach((t) => t.setAttribute('aria-selected', 'false'))

      tab.setAttribute('aria-selected', 'true')
    })
  })
}

// footer newsletter validation

const newsletterEmailField = document.getElementById('footer-subscribe-email')
const newsletterEmailWrapper = document.querySelector('.footer__newsletter-inner')
const newsletterErrorMessage = document.querySelector('.footer__newsletter-validation')

const validateEmail = (email) => {
  const atSignTest = email.includes('@')
  const tldTest = /\.[a-zA-Z]{2,}$/.test(email)
  const invalidCharsTest = /[^a-zA-Z0-9@._-]/.test(email)

  if (invalidCharsTest) {
    return 'The email contains invalid characters.'
  } else if (!atSignTest) {
    return 'The email should include an @ sign, e.g., taylor@gmail.com.'
  } else if (!tldTest) {
    return 'The email should include a TLD, e.g., .com, .net.'
  }

  return ''
}

const clearNewsletterField = () => {
  newsletterEmailWrapper.classList.remove('invalid')
  newsletterErrorMessage.classList.remove('visible')
  newsletterErrorMessage.textContent = ''
}

newsletterEmailField.addEventListener('input', () => {
  const emailValue = newsletterEmailField.value
  const validationMessage = validateEmail(emailValue)

  if (emailValue.length > 0 && validationMessage) {
    newsletterEmailWrapper.classList.add('invalid')
    newsletterErrorMessage.classList.add('visible')
    newsletterErrorMessage.textContent = validationMessage
  } else {
    clearNewsletterField()
  }
})

// generic mutation observer

function lfObserveAttributeChange(elementSelector, attributeName, callback) {
  const targetElements = document.querySelectorAll(elementSelector)
  const observerCallback = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === attributeName) {
        callback(mutation.target, mutation.target.getAttribute(attributeName))
      }
    }
  }

  const observer = new MutationObserver(observerCallback)
  const observerOptions = {
    attributes: true,
    attributeFilter: [attributeName]
  }

  targetElements.forEach(element => {
    observer.observe(element, observerOptions)
  })

  return () => observer.disconnect()
}

// get all reset buttons

const filterResetButtonGroup = document.querySelectorAll('.filter-group__reset')

// disable all reset buttons on load

filterResetButtonGroup.forEach((t) => t.setAttribute('inert', ''))

// observe all filter options

lfObserveAttributeChange('#filter-bar-filters .filter-group', 'class', (element) => {
  // toggle inert property on reset buttons to prevent tabbing

  const resetButton = element.querySelector('.filter-group__reset')

  if (element.classList.contains('filter-group--active') && resetButton.classList.contains('active')) {
    resetButton.removeAttribute('inert')
  } else {
    resetButton.setAttribute('inert', '')
  }
})

// handle product card image update when clicking swatches 
if (!customElements.get('swatches-plp')) {
  customElements.define('swatches-plp', class SwatchesPLP extends HTMLElement {
    constructor() {
      super();
      this.imageUrl = this.getAttribute('data-swatch-image-url');
      this.imageAlt = this.getAttribute('data-swatch-image-alt');
      this.itemContainer = this.closest('.product-item__inner')?.querySelector('.product-item__image-link');
    }

    connectedCallback() {
      this.addEventListener('click', this.updateCardImage.bind(this));
    }

    updateCardImage() {
      if (this.itemContainer && this.imageUrl) {
        this.itemContainer.innerHTML = '';
        const div = document.createElement('div');
        div.classList.add('image', 'product-item__image');
        const img = document.createElement('img');
        img.classList.add('image__img');
        img.setAttribute('src', this.imageUrl);
        img.setAttribute('alt', this.imageAlt);
        div.appendChild(img);
        console.log(div);
        this.itemContainer.appendChild(div)
      }
    }
  });
}

// handle customized products(bundled) remove feature in the sidecart or cart page 
if (!customElements.get('bundle-remove-button')) {
  customElements.define('bundle-remove-button', class SwatchesPLP extends HTMLElement {
    constructor() {
      super();
      this.customizationId = this.getAttribute('data-customizationId');
    }

    connectedCallback() {
      this.addEventListener('click', this.itemRemoveBundle.bind(this));
    }

    async itemRemoveBundle() {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const items = cart.items.filter(item => item.properties._customizationId == this.customizationId);

      const tmpObj = {};
      items.forEach((item) => (tmpObj[item.key] = 0));

      const result = await fetch("/cart/update.js", {
        body: JSON.stringify({ updates: tmpObj }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const cartInstance = window.Shopify.theme.sections.instances.find(instance => instance.id.includes('quick-cart'));
      if (cartInstance && cartInstance.refreshQuickCart) {
        cartInstance.refreshQuickCart();
      }
    }
  });
}

//a new featured collection slider section with auto scroll feature
if (!customElements.get('featured-collection-auto-slider')) {
  customElements.define('featured-collection-auto-slider', class AutoScroll extends HTMLElement {
    constructor() {
      super();
      this.swiper = this.querySelector('.swiper');
      const {
        productsPerView,
        mobileProductsPerView,
        enableAutoplay,
        autoplay,
        enableLoop,
        disableInteraction,
        dragable
      } = this.dataset;
      this.perView = parseInt(productsPerView, 10);
      this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05;
      this.enableAutoplay = enableAutoplay === "true";
      this.autoplay = autoplay;
      this.loop = enableLoop === "true";
      this.disableInteraction = disableInteraction === "true";
      this.dragable = dragable === "true";
      this.prevButton = this.querySelector('button[data-prev]');
      this.nextButton = this.querySelector('button[data-next]');
      this.swiperInstance;
      this.resizeTimeout;
    }

    connectedCallback() {
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.initSwiper();
        }, 300); // Debounce delay
      });
      this.initSwiper();
    }

    initSwiper() {
      const breakpoint = 720;
      const isDesktop = window.innerWidth >= breakpoint;

      const config = this.enableAutoplay && isDesktop ? {
        slidesPerView: this.mobilePerView,
        loop: this.loop,
        autoplay: {
          delay: this.autoplay, // milliseconds between slide transitions
          disableOnInteraction: this.disableInteraction
        },
        direction: 'horizontal',
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1
        },
        allowTouchMove: this.dragable,
        spaceBetween: 13,
        breakpoints: {
          720: {
            spaceBetween: 17,
            // matches product grid
            slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView
          },
          1200: {
            spaceBetween: 25,
            // matches product grid
            slidesPerView: this.perView
          }
        }
      } : {
        slidesPerView: this.mobilePerView,
        loop: this.loop,
        direction: 'horizontal',
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1
        },
        allowTouchMove: this.dragable,
        spaceBetween: 13,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: {
          720: {
            spaceBetween: 17,
            // matches product grid
            slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView
          },
          1200: {
            spaceBetween: 25,
            // matches product grid
            slidesPerView: this.perView
          }
        }
      }

      // If there's already an instance, destroy it before reinitializing
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      this.swiperInstance = new Swiper(this.swiper, config);
    }
  });
}

//Loads more products from a given collection
if (!customElements.get('featured-collection-view-more')) {
  customElements.define('featured-collection-view-more', class FeatureCollectionViewMore extends HTMLElement {
    constructor() {
      super();
      this.loadMoreBtn = this.querySelector('.view-more__button');
      this.showMoreBtn = this.querySelector('.show-more__button');
      this.showLessBtn = this.querySelector('.show-less__button');
      this.itemContainer = this.querySelector('.featured-collection-slider__products');
      const {
        collectionUrl,
        productsPerRow,
        mobileProductsPerRow,
        showProducts,
        productsPerPage,
        maxProductsInCollection,
        maxPages
      } = this.dataset;
      this.productsPerRow = parseInt(productsPerRow, 10);
      this.mobileProductsPerRow = parseInt(mobileProductsPerRow, 10);
      this.productsPerPage = parseInt(productsPerPage, 10);
      this.maxProductsInCollection = parseInt(maxProductsInCollection, 10);
      this.collectionUrl = collectionUrl;
      this.showProducts = parseInt(showProducts, 10);
      this.maxPages = parseInt(maxPages, 10);
      this.page = 1;
      this.currentItemCount = this.showProducts;
      this.noMoreLoad = false;
    }

    connectedCallback() {
      this.loadMoreBtn?.addEventListener('click', this.loadMoreProducts.bind(this));
      this.loadMoreBtn?.setAttribute('aria-label', `Load more products, currently showing ${this.showProducts} products`);
      this.loadMoreBtn?.setAttribute('aria-live', 'polite');

      this.showMoreBtn?.addEventListener('click', this.showMoreProducts.bind(this));
      this.showLessBtn?.addEventListener('click', this.showLessProducts.bind(this));
    }

    loadMoreProducts() {
      const nextPage = this.page + 1;
      fetch(`${this.collectionUrl}?page=${nextPage}`)
        .then(response => response.text())
        .then(text => {
          const source = new DOMParser().parseFromString(text, "text/html").querySelectorAll(".collection__products .product-item");
          // If the source is empty, disable the button and update text
          if (!source || source.length === 0) return;

          source.forEach((item) => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('featured-collection-slider__product', `grid-${this.productsPerRow}`, `grid-${this.mobileProductsPerRow}__mobile`);
            wrapper.appendChild(item);
            this.itemContainer.appendChild(wrapper);
          });

          if (nextPage > this.maxPages) {
            this.noMoreLoad = true;
            this.loadMoreBtn.textContent = 'No more products to load';
            this.loadMoreBtn.setAttribute('disabled', 'true');
            this.loadMoreBtn.setAttribute('aria-label', 'No more products to load');
            this.loadMoreBtn.setAttribute('aria-live', 'off');
            this.loadMoreBtn.classList.add('hide');
            this.showLessBtn?.classList.remove('hide');
            this.showLessBtn?.setAttribute('aria-label', 'Show less products');
            this.showLessBtn?.setAttribute('aria-live', 'polite');
          }

          this.currentItemCount = this.currentItemCount + source.length;
          this.page = nextPage;
          this.setAttribute('data-page', this.page);

        }).catch(error => {
          console.error('Error loading more products:', error);
        });
    }

    // Show more products when the button is clicked
    // This will reveal all hidden products in the collection
    showMoreProducts() {
      if (this.noMoreLoad) {
        let count = 0;
        const range = this.productsPerRow * 2;
        this.itemContainer.querySelectorAll('.featured-collection-slider__product').forEach((item, index) => {
          if (index < (this.currentItemCount + range)) {
            item.classList.remove('hide');
            count += 1;
          }
        });
        const totalItems = this.itemContainer.querySelectorAll('.featured-collection-slider__product').length;
        if (totalItems <= this.currentItemCount + range) {
          this.showMoreBtn?.classList.add('hide');
          this.showLessBtn?.classList.remove('hide');
          this.showLessBtn?.setAttribute('aria-label', 'Show less products');
          this.showLessBtn?.setAttribute('aria-live', 'polite');
        }
        this.currentItemCount += range;
      } else {
        let count = 0;
        this.itemContainer.querySelectorAll('.featured-collection-slider__product.hide').forEach((item) => {
          item.classList.remove('hide');
          count += 1;
        });
        this.currentItemCount = this.showProducts + count;
        this.showMoreBtn?.classList.add('hide');
        if (this.loadMoreBtn) {
          this.loadMoreBtn?.classList.remove('hide');
          this.loadMoreBtn?.setAttribute('aria-label', `Load more products, currently showing ${this.currentItemCount} products`);
          this.loadMoreBtn?.setAttribute('aria-live', 'polite');
        } else {
          this.showLessBtn?.classList.remove('hide');
          this.showLessBtn?.setAttribute('aria-label', 'Show less products');
          this.showLessBtn?.setAttribute('aria-live', 'polite');
        }

      }
    }

    showLessProducts() {
      this.itemContainer.querySelectorAll('.featured-collection-slider__product').forEach((item, index) => {
        if (index >= this.showProducts) {
          item.classList.add('hide');
        }
      });
      this.currentItemCount = this.showProducts;
      this.showMoreBtn?.classList.remove('hide');
      this.loadMoreBtn?.classList.add('hide');
      this.loadMoreBtn?.removeAttribute('aria-label');
      this.loadMoreBtn?.setAttribute('aria-label', `Load more products, currently showing ${this.currentItemCount} products`);
      this.loadMoreBtn?.setAttribute('aria-live', 'off');

      this.showLessBtn?.classList.add('hide');
      this.showLessBtn?.setAttribute('aria-label', 'Show less products');
      this.showLessBtn?.setAttribute('aria-live', 'off');

      this.itemContainer.scrollIntoView({
        behavior: 'smooth',
        block: "start"
      });
    }
  });
}

// Create “Read More“ button on the paragraph that collapses by default. It will show just 3 lines of text on Desktop and Mobile.
if (!customElements.get('collapsible-text')) {
  customElements.define('collapsible-text', class CollapsibleText extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.section-blocks__text');
      this.allTextContent = this.container.querySelectorAll(':scope > *');
      this.loadMoreContent = false;
    }

    connectedCallback() {
      if (!this.container) return;
      this.container.classList.add('max-3-line');
      var allTextsHeight = 0;
      this.allTextContent.forEach(text => allTextsHeight += text.clientHeight);
      if (allTextsHeight > this.container.clientHeight) {
        const button = document.createElement('button');
        button.classList.add('collapsible-text-control');
        button.textContent = "Read More";
        button.addEventListener('click', this.toggle.bind(this));
        this.container.append(button);
      }
    }

    toggle() {
      const button = this.querySelector('.collapsible-text-control');
      if (!button || !this.container) return;

      if (this.loadMoreContent) {
        button.textContent = "Read more";
        this.container.classList.add('max-3-line');
        this.loadMoreContent = false;
      } else {
        button.textContent = "Read less";
        this.container.classList.remove('max-3-line');
        this.loadMoreContent = true;
      }
    }
  });
}

// Create “Read More“ button on the paragraph that collapses by default. It will show just 3 lines of text on Desktop and Mobile.
if (!customElements.get('zoom-in-container')) {
  customElements.define('zoom-in-container', class ZoomInContainer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('mouseover', this.scaleUp.bind(this));
      this.addEventListener('mouseout', this.scaleDown.bind(this));
      this.addEventListener('mousemove', this.zoomRepositionMouse.bind(this));
    }

    scaleUp() {
      this.style.transform = 'scale(3)';
    }

    scaleDown() {
      this.style.transform = 'scale(1)';
    }

    zoomRepositionMouse(e) {
      const rect = this.getBoundingClientRect();
      const offsetX = e.pageX - (rect.left + window.scrollX);
      const offsetY = e.pageY - (rect.top + window.scrollY);
      const originX = (offsetX / rect.width) * 100 + '%';
      const originY = (offsetY / rect.height) * 100 + '%';
      const transformOrigin = originX + ' ' + originY;
      this.style.transformOrigin = transformOrigin;
    }
  });
}

// Create “Read More“ button on the paragraph that collapses by default. It will show just 3 lines of text on Desktop and Mobile.
if (!customElements.get('gift-wrapping-widget')) {
  customElements.define('gift-wrapping-widget', class giftWrappingWidget extends HTMLElement {
    constructor() {
      super();
      this.GIFT_MESSAGE_MAX_LENGT = 100;
    }

    connectedCallback() {
      this.giftConsent = this.querySelector('#gift-consent');
      this.giftMessageContainer = this.querySelector('.gift-message-container');
      this.giftMessage = this.querySelector('#gift-message');
      this.charCount = this.querySelector('#char-count');
      this.giftMessagePriceSpan = this.querySelector('#gift-message-price');
      this.giftMessageIdInput = this.querySelector('#gift-message-id');

      this.giftBoxContainer = this.querySelector('.gift-box-container');
      this.giftBoxConsent = this.querySelector('#gift-box');
      this.giftBoxIdInput = this.querySelector('#gift-box-id');
      this.giftBoxTitleInput = this.querySelector('#gift-box-title');
      this.giftBoxPriceSpan = this.querySelector('#gift-box-price');
      this.giftBoxColorSwatches = this.querySelectorAll('.gift-box-container .product__color-swatch');

      this.addToCart = this.querySelector('#gifts-add-to-cart');

      this.giftConsent?.addEventListener('change', this.toggle.bind(this));
      this.giftBoxConsent?.addEventListener('change', this.enableGiftBoxIdInput.bind(this));
      this.giftMessage?.addEventListener('input', this.handleGiftMessageChange.bind(this));
      this.giftBoxColorSwatches.forEach(swatch => swatch.addEventListener('click', this.handleGiftBoxVariantUpdate.bind(this)));
      this.addToCart?.addEventListener('click', this.handleAddGiftToCart.bind(this));
    }

    toggle(e) {
      const isGift = e.target.checked;
      isGift ? this.show() : this.hide();
    }

    enableGiftBoxIdInput(e) {
      const checked = e.target.checked;
      if (checked) {
        if (this.giftBoxIdInput) this.giftBoxIdInput.disabled = false;
        if (this.giftBoxTitleInput) this.this.giftBoxTitleInput.disabled = false;
        this.giftBoxPriceSpan?.classList.remove('force-display-none')
      } else {
        if (this.giftBoxIdInput) this.giftBoxIdInput.disabled = true;
        if (this.giftBoxTitleInput) this.this.giftBoxTitleInput.disabled = true;
        this.giftBoxPriceSpan?.classList.add('force-display-none')
      }
    }

    handleGiftMessageChange() {
      if (this.giftMessage.value.length == 0) {
        this.giftMessagePriceSpan?.classList.add('force-display-none');
        if (this.giftMessageIdInput) this.giftMessageIdInput.disabled = true;
      } else {
        this.giftMessagePriceSpan?.classList.remove('force-display-none');
        if (this.giftMessageIdInput) this.giftMessageIdInput.disabled = false;
      }

      if (this.giftMessage.value.length > this.GIFT_MESSAGE_MAX_LENGT) {
        this.giftMessage.value = this.giftMessage.value.substring(0, this.GIFT_MESSAGE_MAX_LENGT);
      }

      if (this.charCount) this.charCount.textContent = `${this.giftMessage.value.length} / ${this.GIFT_MESSAGE_MAX_LENGT}`;
    }

    handleGiftBoxVariantUpdate(e) {
      const target = e.target;
      if (this.currentActiveSwatch && this.currentActiveSwatch == target) {
        this.giftBoxConsent.checked = false;
        this.giftBoxIdInput.disabled = true;
        this.giftBoxTitleInput.disabled = true;
        this.currentActiveSwatch = null;
        target.classList.remove('selected');
        this.giftBoxPriceSpan.classList.add('force-display-none');
        return;
      }

      this.giftBoxConsent.checked = true;
      this.giftBoxIdInput.disabled = false;
      this.giftBoxTitleInput.disabled = false;
      this.giftBoxColorSwatches.forEach(swatch => swatch.classList.remove('selected'));
      target.classList.add('selected');
      this.currentActiveSwatch = target;

      const variantPrice = target.getAttribute('data-variant-price');
      const variantId = target.getAttribute('data-variant-id');
      const variantTitle = target.getAttribute('data-variant-title');
      this.giftBoxPriceSpan.textContent = variantPrice;
      this.giftBoxPriceSpan.classList.remove('force-display-none');
      this.giftBoxIdInput.value = variantId;
      this.giftBoxTitleInput.value = variantTitle;
    }

    async getMainProductByKey(key) {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const mainProductItem = cart?.items?.find(item => item.key == key);

      return mainProductItem;
    }

    async changeCartItem(item) {
      const result = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      });
      if (result.status == 200) {
        return 'success'
      } else {
        return 'fail'
      }
    }

    async addItemsToCart(items) {
      const formData = { items };
      const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (result.status == 200) {
        return 'success'
      } else {
        return 'fail'
      }
    }

    async handleAddGiftToCart(e) {
      const button = e.target;
      const mainProductKey = button.getAttribute('data-main-product-key');
      const mainProductItem = await this.getMainProductByKey(mainProductKey);
      const quantity = mainProductItem.quantity;
      const properties = mainProductItem.properties;
      const newItems = [];
      if (this.giftMessageIdInput && !this.giftMessageIdInput.disabled) {
        properties['Gift Message'] = this.giftMessage.value;
        properties['_gift_message'] = this.giftMessageIdInput.value;

        const giftMessageVariantId = this.giftMessageIdInput.value.split('_')[0];
        newItems.push({
          'id': giftMessageVariantId,
          'quantity': quantity,
          'properties': {
            '_gift_message': this.giftMessageIdInput.value,
            'Gift Message': this.giftMessage.value
          }
        });
      }
      if (this.giftBoxIdInput && !this.giftBoxIdInput.disabled) {
        properties['_gift_wrap'] = this.giftBoxIdInput.value;
        properties['Gift Box'] = this.giftBoxTitleInput.value;

        const giftBoxVariantId = this.giftBoxIdInput.value.split('_')[0];
        newItems.push({
          'id': giftBoxVariantId,
          'quantity': quantity,
          'properties': {
            '_gift_wrap': this.giftBoxIdInput.value,
          }
        });
      }


      if (newItems.length > 0) {
        //Update main product properties
        const change = await this.changeCartItem({ id: mainProductKey, properties });
        //Add gift products
        const added = await this.addItemsToCart(newItems);
        if (change == 'success' || added == 'success') {
          window.location.href = '/cart';
        }
      }
    }

    show() {
      this.giftMessageContainer?.classList.remove('force-display-none');
      this.giftBoxContainer?.classList.remove('force-display-none');
      this.addToCart?.classList.remove('force-display-none');
      if (this.giftMessage) this.giftMessage.disabled = false;
    }

    hide() {
      this.giftMessageContainer?.classList.add('force-display-none');
      this.giftBoxContainer?.classList.add('force-display-none');
      this.addToCart?.classList.add('force-display-none');
      this.reset();
    }

    reset() {
      if (this.giftMessage) {
        this.giftMessage.value = "";
        this.giftMessage.disabled = true;
      }
      if (this.giftMessageIdInput) this.giftMessageIdInput.disabled = true;
      if (this.charCount) this.charCount.textContent = `0 / ${this.GIFT_MESSAGE_MAX_LENGT}`;
      this.giftMessagePriceSpan?.classList.add('force-display-none');

      if (this.giftBoxConsent) this.giftBoxConsent.checked = false;
      if (this.giftBoxIdInput) this.giftBoxIdInput.disabled = true;
      if (this.giftBoxPriceSpan) this.giftBoxPriceSpan.classList.add('force-display-none');
      this.currentActiveSwatch = null;
      this.giftBoxColorSwatches.forEach(swatch => swatch.classList.remove('selected'));
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[custom-add-to-cart-button]');
  const productId = button?.getAttribute('custom-add-to-cart-product-id');
  console.log('Custom add to cart script loaded.', button, productId);
  if (!button) return;

  button.addEventListener("click", () => {
    // Wait for Dubow script to finish its own fetch('/cart/add.js')
    setTimeout(() => {
      addGiftItemsIfNeeded(productId);
    }, 3000);
  });
});


async function addGiftItemsIfNeeded(productId) {
  const giftWrappingWidget = document.querySelector('gift-wrapping-widget');
  console.log('giftWrappingWidget.giftMessage.value', giftWrappingWidget.giftMessage.value);
  console.log('Checking for gift items to add for product ID:', productId);
  if (!productId) return;

  // Get last added line item
  const cart = await fetch('/cart.js').then(r => r.json());
  const thisLineItem = cart.items.find(item => item.product_id == Number(productId));
  console.log('thisLineItem', thisLineItem);

  if (!thisLineItem || !thisLineItem.properties._productCustomized || giftWrappingWidget.giftMessage.value === '') {
    console.log('No gift items to add or gift message is empty or product is not customized.');
    return;
  }

  const props = { ...thisLineItem.properties };
  props['_paired_line_item_key'] = thisLineItem.key;
  props['_gift_message'] = giftWrappingWidget.giftMessageIdInput.value;
  props['Gift Message'] = giftWrappingWidget.giftMessage.value;
  const items = [];


  // 🎁 Gift Wrap
  if (giftWrappingWidget.giftBoxIdInput && !giftWrappingWidget.giftBoxIdInput.disabled) {
    props['_gift_wrap'] = giftWrappingWidget.giftBoxIdInput.value;
    props['Gift Box'] = giftWrappingWidget.giftBoxTitleInput.value;
    const splits = props._gift_wrap.split('_');
    if (splits.length === 2) {
      items.push({
        id: splits[0],
        quantity: thisLineItem.quantity,
        properties: { _gift_wrap: props._gift_wrap, _paired_line_item_key: thisLineItem.key }
      });
    }
  }

  // ✉️ Gift Message
  if (props._gift_message && props["Gift Message"]) {
    const splits = props._gift_message.split('_');
    if (splits.length === 2) {
      items.push({
        id: splits[0],
        quantity: thisLineItem.quantity,
        properties: {
          _gift_message: props._gift_message,
          "Gift Message": props["Gift Message"],
          _paired_line_item_key: thisLineItem.key
        }
      });
    }
  }

  console.log('props', props);

  if (items.length === 0) return;

  console.log("Adding gift items:", items);

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });
  
  window.location.href = '/cart';
}
